import React, {
  useState, useCallback, memo,
} from 'react';
import noop from 'lodash/noop';
import AmountField from '../AmountField';

const TipAmountField = (props) => {
  const {
    fieldType, trackingCallback = noop, resetContentHeight = noop,
  } = props;
  const [ isShowProcessingFeeTipMsg, setShowProcessingFeeTipMsg ] = useState(false);
  const toggleShowProcessingFeeTipMsg = useCallback(() => {
    setShowProcessingFeeTipMsg(!isShowProcessingFeeTipMsg);
    !isShowProcessingFeeTipMsg && trackingCallback({ id: `cui.${fieldType}.tipShow` });
    resetContentHeight();
  }, [ isShowProcessingFeeTipMsg, fieldType ]);
  const handleMouseOver = useCallback(() => {
    trackingCallback({ id: `cui.${fieldType}.tipShow` });
  }, [ fieldType, trackingCallback ]);

  return (
    <AmountField
      {...props}
      handleMouseOver={handleMouseOver}
      isShowTipMsg={isShowProcessingFeeTipMsg}
      toggleShowTipMsg={toggleShowProcessingFeeTipMsg}/>
  );
};

export default memo(TipAmountField);
